import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { environmentFlag } from './utils/systemEnums';
import { AuthServiceLocal } from 'src/@order/services/auth.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { FacebookApiService } from 'src/@order/services/FacebookApi.service';
import { DeviceIdService } from 'src/@order/services/device-id.service';
import { SwUpdate } from '@angular/service-worker';
import { AutoUpdateDialogComponent } from 'src/@order/dialogs/auto-update-dialog/auto-update-dialog.component';
import { MatDialog } from '@angular/material/dialog';
declare global {
  interface Window {
    dataLayer: any[];
  }

  var fbq: any;

}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  deviceInfo = null;
  deviceId: string = '';
  constructor(private deviceIdService: DeviceIdService,
    private _message: MatSnackBar, private _auth: AuthServiceLocal, private deviceService: DeviceDetectorService, private _matDialog: MatDialog,
    private swUpdate: SwUpdate) {

    if (!this._auth.api_version) {
      this._auth.getApiVersion()
    }

    this.epicFunction();

    console.log(environmentFlag, "ready UPDATED ON 17-02-2025");
    this.deviceId = this.deviceIdService.getDeviceId();
    if (environmentFlag == 'prod') {
      console.log = function () { };
      console.error = function () { };
      console.warn = function () { };
      console.info = function () { };
    }

    // Add global error handler for Google Maps
    this.setupGlobalErrorHandler();
  }


  private setupGlobalErrorHandler() {
    // Handle unhandled promise rejections (like Google Maps errors)
    window.addEventListener('unhandledrejection', (event) => {
      if (event.reason?.message?.includes('vI') ||
        event.reason?.message?.includes('Google Maps') ||
        event.reason?.message?.includes('loading=async') ||
        event.reason?.stack?.includes('maps.googleapis.com')) {
        console.warn('Google Maps related error (suppressed):', event.reason);
        event.preventDefault(); // Prevent the error from appearing in console
        return;
      }
    });

    // Handle general errors
    window.addEventListener('error', (event) => {
      if (event.error?.message?.includes('vI') ||
        event.error?.message?.includes('Google Maps') ||
        event.error?.message?.includes('loading=async') ||
        event.filename?.includes('maps.googleapis.com')) {
        console.warn('Google Maps related error (suppressed):', event.error);
        event.preventDefault(); // Prevent the error from appearing in console
        return;
      }
    });
  }

  ngOnInit() {

    console.log("26-08-2025");



    // console.log("swUpdate", this.swUpdate);
    // if (this.swUpdate.isEnabled) {
    //   // Check for updates when app initializes
    //   this.swUpdate.checkForUpdate();

    //   // Subscribe to available updates
    //   this.swUpdate.versionUpdates.subscribe(event => {

    //     console.log("swUpdate event", event);
    //     if (event.type === 'VERSION_READY') {
    //       console.log('New version available:', event.latestVersion);



    //       const dialog = this._matDialog.open(AutoUpdateDialogComponent, {
    //         backdropClass: "dialogBackdrop",
    //         width: "450px",
    //         disableClose: true,
    //         data: {
    //           heading: "Force Update.",
    //           content: "New version available. Load new version?",
    //           actionText: "Update App Now",
    //         },
    //       }
    //       ).afterClosed().subscribe(() => {
    //         this.swUpdate.activateUpdate().then(() => {
    //           window.location.reload();
    //         });
    //         // window.location.reload();
    //       });


    //       // // You can prompt the user to refresh

    //     }
    //   });

    //   // // You can also periodically check for updates
    //   setInterval(() => {
    //     this.swUpdate.checkForUpdate();
    //   }, 2 * 60 * 1000); // Check 

    // }


    // // Check if Service Worker is registered, if not, register it
    // // This setInterval runs every 2 minutes and can cause issues
    // setInterval(() => {
    //   if (!navigator.serviceWorker.controller) {
    //     console.log('Service Worker not registered, registering now...');
    //     navigator.serviceWorker.register('/ngsw-worker.js').then(registration => {
    //       console.log('Service Worker registered successfully:', registration);
    //     }).catch(err => {
    //       console.error('Service Worker registration failed:', err);
    //     });
    //   } else {
    //     console.log('Service Worker already registered.');
    //   }
    // }, 2 * 60 * 1000); // Check every 2 minutes
  }

  epicFunction() {
    console.log('hello `Home` component ');
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
    console.log("deviceInfo", this.deviceInfo);
    console.log("isMobile", isMobile);  // returns if the device is a mobile device (android / iPhone / windows-phone etc)
    console.log("isTablet", isTablet);  // returns if the device us a tablet (iPad etc)
    console.log("isDesktopDevice", isDesktopDevice); // returns if the app is running on a Desktop browser.
  }
}
